var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('JobStatusList'),(_vm.showProjectTab === true)?_c('ProjectStatusList'):_vm._e(),_c('HelloWorld')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }